import { useCallback, useEffect, useState } from "react";
import {
  CART_STORAGE_KEY, EMPTY_CART, addToCart, cartCount, loadCart, quantityOf, removeFromCart,
  quantityOfProduct, repriceCart, saveCart, setQuantity, type ShowroomCart,
} from "@/lib/showroom-cart";
import type { EditorItem } from "@/lib/wholesale-items";

/** `localStorage` ume da baci (privatni prozor, ugašeni kolačići) — prezentacija tada
 *  radi bez pamćenja umjesto da padne. */
function readStorage(): string | null {
  try {
    return localStorage.getItem(CART_STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeStorage(value: string) {
  try {
    localStorage.setItem(CART_STORAGE_KEY, value);
  } catch {
    /* prezentacija se nastavlja, samo bez pamćenja preko osvježavanja */
  }
}

/** Korpa prezentacijskog moda: stanje u pregledniku, snimak u `localStorage` nakon
 *  svake izmjene, jer se tablet na terenu zaključa ili tab osvježi. */
export function useShowroomCart() {
  const [cart, setCart] = useState<ShowroomCart>(() => loadCart(readStorage()));

  useEffect(() => {
    writeStorage(saveCart(cart));
  }, [cart]);

  return {
    cart,
    count: cartCount(cart),
    quantityOf: useCallback((key: string) => quantityOf(cart, key), [cart]),
    quantityOfProduct: useCallback(
      (storeId: string, wcProductId: number) => quantityOfProduct(cart, storeId, wcProductId),
      [cart],
    ),
    setPartnerId: useCallback((partnerId: string | null) => setCart((c) => ({ ...c, partnerId })), []),
    add: useCallback((item: EditorItem) => setCart((c) => addToCart(c, item)), []),
    setQuantity: useCallback((key: string, qty: number) => setCart((c) => setQuantity(c, key, qty)), []),
    remove: useCallback((key: string) => setCart((c) => removeFromCart(c, key)), []),
    reprice: useCallback(
      (partnerDiscount: number, storeDiscounts?: { storeId: string; discountPct: number }[]) =>
        setCart((c) => repriceCart(c, partnerDiscount, storeDiscounts)),
      [],
    ),
    clear: useCallback(() => setCart(EMPTY_CART), []),
  };
}
